'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var BufferList = require('bl/BufferList');

var lp = require('it-length-prefixed');

var pipe = require('it-pipe');

var errCode = require('err-code');

var NewLine = Buffer.from('\n');

function oneChunk(source) {
  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

  return _regeneratorRuntime.async(function oneChunk$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _context.prev = 2;
          _iterator = _asyncIterator(source);

        case 4:
          _context.next = 6;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 6:
          _step = _context.sent;
          _iteratorNormalCompletion = _step.done;
          _context.next = 10;
          return _regeneratorRuntime.awrap(_step.value);

        case 10:
          _value = _context.sent;

          if (_iteratorNormalCompletion) {
            _context.next = 17;
            break;
          }

          chunk = _value;
          return _context.abrupt("return", chunk);

        case 14:
          _iteratorNormalCompletion = true;
          _context.next = 4;
          break;

        case 17:
          _context.next = 23;
          break;

        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](2);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 23:
          _context.prev = 23;
          _context.prev = 24;

          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
            _context.next = 28;
            break;
          }

          _context.next = 28;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 28:
          _context.prev = 28;

          if (!_didIteratorError) {
            _context.next = 31;
            break;
          }

          throw _iteratorError;

        case 31:
          return _context.finish(28);

        case 32:
          return _context.finish(23);

        case 33:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[2, 19, 23, 33], [24,, 28, 32]], Promise);
}

exports.encode = function (buffer) {
  return lp.encode.single(new BufferList([buffer, NewLine]));
}; // `write` encodes and writes a single buffer


exports.write = function (writer, buffer) {
  return writer.push(exports.encode(buffer));
}; // `writeAll` behaves like `write`, except it encodes an array of items as a single write


exports.writeAll = function (writer, buffers) {
  writer.push(buffers.reduce(function (bl, buffer) {
    return bl.append(exports.encode(buffer));
  }, new BufferList()));
};

exports.read = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reader) {
    var _varByteSource;

    var byteLength, varByteSource, onLength, buf;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            byteLength = 1; // Read single byte chunks until the length is known

            varByteSource = (_varByteSource = {}, _defineProperty(_varByteSource, Symbol.asyncIterator, function () {
              return this;
            }), _defineProperty(_varByteSource, "next", function next() {
              return reader.next(byteLength);
            }), _varByteSource); // Once the length has been parsed, read chunk for that length

            onLength = function onLength(l) {
              byteLength = l;
            };

            _context2.next = 5;
            return pipe(varByteSource, lp.decode({
              onLength: onLength
            }), oneChunk);

          case 5:
            buf = _context2.sent;

            if (!(buf.get(buf.length - 1) !== NewLine[0])) {
              _context2.next = 8;
              break;
            }

            throw errCode(new Error('missing newline'), 'ERR_INVALID_MULTISTREAM_SELECT_MESSAGE');

          case 8:
            return _context2.abrupt("return", buf.shallowSlice(0, -1));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();